import { api } from "./api";

const PUBLIC_KEY =
  process.env.REACT_APP_VAPID_PUBLIC_KEY ||
  process.env.NX_REACT_APP_VAPID_PUBLIC_KEY;

const base64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const isPushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window;

export const getPermissionStatus = () => {
  if (!("Notification" in window)) return "unsupported";
  return Notification.permission;
};

export const requestPermissionIfNeeded = async () => {
  if (!("Notification" in window)) {
    throw new Error("Le notifiche non sono supportate da questo browser");
  }
  if (Notification.permission === "granted") return "granted";
  if (Notification.permission === "denied") {
    throw new Error("Permesso notifiche negato. Abilitalo dalle impostazioni del browser.");
  }
  const result = await Notification.requestPermission();
  if (result !== "granted") {
    throw new Error("Permesso notifiche non concesso");
  }
  return result;
};

const fetchPublicKey = async () => {
  const { data } = await api.get("/push/public-key");
  return data?.publicKey;
};

const getVapidKey = async () => {
  if (PUBLIC_KEY) return PUBLIC_KEY;
  const key = await fetchPublicKey();
  if (!key) throw new Error("Chiave pubblica VAPID non disponibile");
  return key;
};

export const registerServiceWorker = async () => {
  // Registra il SW statico servito da /sw.js
  const registration = await navigator.serviceWorker.register("/sw.js");
  return registration;
};

export const subscribePush = async ({ congregazioneId } = {}) => {
  if (!isPushSupported()) {
    throw new Error("Push non supportato da questo dispositivo");
  }

  await requestPermissionIfNeeded();
  const reg = await registerServiceWorker();
  const publicKey = await getVapidKey();

  const subscription = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: base64ToUint8Array(publicKey),
  });

  const body = {
    endpoint: subscription.endpoint,
    keys: subscription.toJSON().keys,
    userAgent: navigator.userAgent,
  };
  if (congregazioneId) {
    body.congregazione_id = congregazioneId;
  }

  await api.post("/push/subscribe", body);
  return subscription;
};

export const ensurePushSubscription = async ({ congregazioneId } = {}) => {
  // Se permission negata, solleva; se granted ma già iscritti, prova a iscrivere comunque per registrare sul server.
  return subscribePush({ congregazioneId });
};

export const unsubscribePush = async () => {
  await api.post("/push/unsubscribe");
  return true;
};

export const fetchPushStatus = async () => {
  const { data } = await api.get("/push/status");
  return data;
};

export const fetchPendingInvite = async () => {
  const { data } = await api.get("/push/pending");
  return data;
};

export const ackPendingInvite = async () => {
  const { data } = await api.post("/push/pending/ack");
  return data;
};
